/**
 * Sets dateStart and dateEnd on an object based on filter data
 * @param {Object} filtersData - The filter data containing date information
 * @param {string} dateFilterName - The name of the date filter field
 * @param {Object} options - Optional configuration
 * @param {boolean} options.useISOFormat - Whether to use ISO string format (default: false)
 * @param {Object} defaultValues - Optional default values to include in the result
 * @returns {Object} - An object with dateStart and dateEnd properties
 */
export function setDateRange(
  filtersData,
  dateFilterName,
  options = {},
  defaultValues = {}
) {
  // Default options
  const { useISOFormat = false } = options;

  // Helper function to format date based on input and options
  const formatDate = (dateString, isStartDate) => {
    // If date string exists, parse it
    if (dateString) {
      const date = new Date(dateString);

      return useISOFormat
        ? date.toISOString()
        : date.toLocaleDateString("en-CA");
    }

    // Otherwise use current date with appropriate time
    const now = new Date();

    if (useISOFormat) {
      // Set time components based on whether it's start or end date
      if (isStartDate) {
        now.setHours(0, 0, 0, 0);
      } else {
        now.setHours(23, 59, 59, 999);
      }

      return now.toISOString();
    } else {
      // For locale format, just return the formatted date
      return now.toLocaleDateString("en-CA");
    }
  };

  // Extract date strings from filters data
  const dateStartString = filtersData?.[dateFilterName]?.dateStartString;
  const dateEndString = filtersData?.[dateFilterName]?.dateEndString;

  // Format dates
  const dateStart = formatDate(dateStartString, true);
  const dateEnd = formatDate(dateEndString, false);

  // Return result with any default values
  return {
    ...defaultValues,
    dateStart,
    dateEnd,
  };
}
